import { Table, Col, CardBody } from "reactstrap";
import React from "react";
import LenderTitle from "../../components/fields/LenderTitle";
import Order from "../../components/fields/Order";
import Product from "../../components/fields/Product";
import "bootstrap/js/src/collapse.js";
import CSVDownload from "../../components/CsvDownload";

const OrderSummaryByOrder = ({ data, filtration }) => {
  if (data === null) {
    return (
        <CardBody className="text-center">
          <h5>Click &quot;Show results&quot; to load data</h5>
        </CardBody>
    );
  }

  if (!data || data.length === 0) {
    return (
        <CardBody className="text-center">
          <h5>Data not found</h5>
        </CardBody>
    );
  }

  return (
      <>
        <div className="row mb-4 mt-1">
          <Col md={12}>
            <div className="d-flex justify-content-end align-items-center">
              <span className='font-weight-bold'>Detail by order</span>&nbsp;<span>Report - </span>
              <CSVDownload
                  url="/admin/lender/summaryorderbyorderexport"
                  filename="OrdersSummaryByOrders"
                  filtration={filtration}
              />
            </div>
          </Col>
        </div>
        <div className="table-responsive">
          <Table striped className="my-0">
            <thead>
            <tr>
              <th>Lender</th>
              <th>Order</th>
              <th>Product</th>
              <th>Sent</th>
              <th>Matched</th>
              <th>Unmatched</th>
              <th>Returned</th>
              <th>Error</th>
              <th>Timeout</th>
              <th>Total</th>
            </tr>
            </thead>
            <tbody>
            {data.map((item, index) => (
                <tr
                    key={index}
                    className={item.lender ? "lender-border-top" : ""}
                >
                  <td className="font-size-lg">
                    {item.lender && <LenderTitle title={item.lender.title} id={item.lender.id}/>}
                  </td>
                  <td>{item.order && <Order order={item.order}/>}</td>
                  <td>{item.order && <Product product={item.order.product}/>}</td>
                  <td className={item.lender ? "font-weight-bold" : "text-primary"}>{item.leads}</td>
                  <td className={item.lender ? "font-weight-bold" : "text-success"}>{item.matched}</td>
                  <td className={item.lender ? "font-weight-bold" : "text-danger"}>{item.unmatched}</td>
                  <td className={item.lender ? "font-weight-bold" : ""}>{item.returned}</td>
                  <td className={item.lender ? "font-weight-bold" : ""}>{item.error}</td>
                  <td className={item.lender ? "font-weight-bold" : ""}>{item.timeout}</td>
                  <td className={item.lender ? "font-weight-bold" : "text-success"}>${item.total}</td>
                </tr>
            ))}
            </tbody>
          </Table>
        </div>
      </>
  );
}

export default OrderSummaryByOrder;
